export type AppointmentStatus = 'In Attesa' | 'Confermato' | 'Completato' | 'Rifiutato';

export interface Appointment {
  id: number;
  client_name: string;
  phone: string;
  email: string;
  service: number;
  service_name: string;
  date: string;            // YYYY-MM-DD
  weekday_name: string;
  time: string;
  notes: string;
  status: AppointmentStatus;
  created_at?: string;
  updated_at?: string;
}

export interface ServiceItem {
  id: number;
  name: string;
  price_eur: number;
  duration_min: number;
  order: number;
}

export interface AvailabilityDay {
  date: string;            // YYYY-MM-DD
  weekday: number;         // 0=Lun..6=Dom
  weekday_name: string;
  is_open: boolean;
  hours: string[];
  occupied: string[];
  source: 'default' | 'override';
  note: string;
}

export interface WeeklyDefaultItem {
  id: number;
  weekday: number;
  weekday_name: string;
  is_open: boolean;
  hours: string[];
}

export interface DateOverrideItem {
  id: number;
  date: string;            // YYYY-MM-DD
  is_open: boolean;
  hours: string[];
  note: string;
}

export type EmailTrigger = 'Confermato' | 'Rifiutato' | 'Completato';

export interface EmailTemplateItem {
  id: number;
  trigger: EmailTrigger;
  enabled: boolean;
  subject: string;
  body: string;
}

export const EMAIL_VARIABLES = [
  '{client_name}', '{service_name}', '{date}', '{weekday}', '{time}', '{notes}',
];

export interface NewBookingPayload {
  client_name: string;
  phone: string;
  email: string;
  service_name: string;
  date: string;            // YYYY-MM-DD
  time: string;
  notes: string;
}

export const WEEKDAY_NAMES = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
export const DEFAULT_HOURS = ['09:00', '10:00', '11:30', '14:30', '16:00', '17:30', '18:30'];
export const ALL_HOURS = ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'];

// Formatter per data utente
export function formatDate(iso: string): string {
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatDateShort(iso: string): string {
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function plusDaysIso(days: number, from?: string): string {
  const base = from ? new Date(from + 'T00:00:00') : new Date();
  base.setDate(base.getDate() + days);
  return base.toISOString().slice(0, 10);
}
